"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmoteIcon = void 0;
var React = __importStar(require("react"));
require("./EmoteIcon.css");
var EmoteIcon = function () { return (React.createElement("div", { className: "EmoteIcon" },
    React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "11", height: "17", viewBox: "0 0 11 17" },
        React.createElement("path", { fillRule: "nonzero", d: "M9.25 11.75H7.75L7.75 16.25H6.25L6.25 11.75L4.66 11.75L3.505 13.1975L5.2825 14.9675L4.2175 16.0325L2.4475 14.255C2.185 14 2.035 13.6475 2.0125 13.28C1.99 12.9125 2.1025 12.545 2.335 12.26L2.74 11.75H1.75L3.25 8.75L3.25 6.5C2.785 6.8525 2.41 7.3025 2.1475 7.82C1.885 8.345 1.75 8.915 1.75 9.5H0.25C0.250199 8.10767 0.803386 6.77243 1.78791 5.78791C2.77243 4.80339 4.10767 4.2502 5.5 4.25C6.4975 4.25 7.45 3.8525 8.155 3.155C8.8525 2.45 9.25 1.4975 9.25 0.5L10.75 0.5C10.75 1.49 10.465 2.465 9.9325 3.2975C9.40294 4.13618 8.64608 4.80722 7.75 5.2325V8.75L9.25 11.75ZM7 2C7 2.3 6.91 2.585 6.745 2.8325C6.58 3.08 6.3475 3.275 6.0775 3.3875C5.80284 3.5001 5.501 3.52884 5.21002 3.47012C4.91905 3.41139 4.65198 3.26781 4.4425 3.0575C4.2325 2.8475 4.09 2.585 4.03 2.2925C3.97 2 4 1.7 4.1125 1.43C4.225 1.1525 4.42 0.92 4.6675 0.755C4.915 0.59 5.2 0.5 5.5 0.5C5.8975 0.5 6.28 0.6575 6.5575 0.9425C6.8425 1.22 7 1.6025 7 2Z" })))); };
exports.EmoteIcon = EmoteIcon;
